import { render, staticRenderFns } from "./EmptyStateSection.vue?vue&type=template&id=4b2b6ada&scoped=true"
import script from "./EmptyStateSection.vue?vue&type=script&lang=js"
export * from "./EmptyStateSection.vue?vue&type=script&lang=js"
import style0 from "./EmptyStateSection.vue?vue&type=style&index=0&id=4b2b6ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b6ada",
  null
  
)

export default component.exports